<template>
  <div class="appliancesDetail">
    <el-dialog title="Detail" :visible="isDetail" align="left" :close-on-click-modal ="false" width="50%" @close="close" height="50%">
      <el-row justify="center" type="flex">
        <el-col>
          <highcharts :options='options'></highcharts>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "appliancesDetail",
        props:{
          detailInfo:{
            type:Object,
            default:{}
          }
        },
        data(){
          return {
            isDetail:false,
            options: {
              chart: {
                //width: 1000,
                height: 400,
                zoomType: null,
                enabled: false,
                plotBorderWidth: 2,
                plotBorderColor: 'grey',
                animation: false           //关闭渲染动画
              },
              plotOptions: {
                  series: {
                    turboThreshold: 10000,   //最大渲染点数
                    animation: false,       //关闭渲染动画
                  },
                  line: {
                    dataGrouping: {
                      enabled: false        //关闭数据分组显示，确保页面显示所有数据
                    }
                  }
              },
              title: {
                text: null
              },
              tooltip:{
                enabled: true,
                trigger:'item'
              },
              legend: {
                verticalAlign: 'top',
                align: 'left',
                layout:'vertical',
                floating:true,
                x:30,
                y:0,
              },
              navigation:{
                buttonOptions:{
                  enabled:false
                }
              },
              xAxis: {
                gridLineDashStyle: 'ShortDash',
                gridLineWidth: 1,
                lineColor: 'grey',
                ordinal: false,
                type: 'datetime',
                title: {
                  enabled: false,
                  text: 'Time',
                  style: {
                    color: "black",
                    fontWeight: 1000,
                  }
                },
                dateTimeLabelFormats: {
                  day: ' %H:%M',
                },
                tickInterval: 2 * 60 * 60 * 1000,
                // endOnTick:true,
                max: new Date().getTime(),
                min: new Date(Date.now() - 18 * 1000 * 60 * 60).getTime()
              },
              yAxis: [{
                gridLineDashStyle:'ShortDash',
                gridLineWidth: 1,
                lineColor: 'grey',
                showFirstLabel: true,    //显示坐标轴第一个点
                showLastLabel: true,      //显示最后一个点
                opposite: false,             //坐标轴位置
                //type: 'linear',
                title: {
                  enabled: false
                },
                lineWidth: 2,
                startOnTick: false,
                min: 0,
                // max:350
              }],
              credits: {
                enabled: false,
              },
              navigator: {
                // adaptToUpdatedData: false,
                enabled: false
              },
              series: [{
                  name: 'system_load (%)',
                  type: 'line',
                  //data: this.detailData[0].data,
                  //yAxis: 0,
                  lineWidth: 1.5,
                  color: "#EDC240",
                  showSymbol:false,
                  marker:{
                    enabled:false,
                    symbol:'circle'
                  }
              },{
                  name: 'engine_heap (%)',
                  type: 'line',
                  //data: this.detailData[1].data,
                  //yAxis: 0,
                  lineWidth: 1.5,
                  color: "#AFD8F8",
                  showSymbol:false,
                  marker:{
                    enabled:false,
                    symbol:'circle'
                  }
              },{
                  name: 'etl_heap (%)',
                  type: 'line',
                  //data: this.detailData[2].data,
                  //yAxis: 0,
                  lineWidth: 1.5,
                  color: "#cb4b4b",
                  showSymbol:false,
                  marker:{
                    enabled:false,
                    symbol:'circle'
                  }
                },{
                  name: 'retrieval_heap (%)',
                  type: 'line',
                 // data: this.detailData[3].data,
                  //yAxis: 0,
                  lineWidth: 1.5,
                  color: "#4DA74D",
                  showSymbol:false,
                  marker:{
                    enabled:false,
                    symbol:'circle'
                  }
                }]
            },
          }
        },
      created(){
        this.query();
      },
      methods:{
        query(){
          this.$axios({ 
            method:'get',
              url:'/hdars/hdars/mgmt/getProcessMetricsDataForAppliance?appliance=' + this.detailInfo.instance
            }).then((response) => {
            this.options.series[0].data = response.data[0].data;
            this.options.series[1].data = response.data[1].data;
            this.options.series[2].data = response.data[2].data;
            this.options.series[3].data = response.data[3].data;
            this.isDetail = true;
          })
        },
        close:function(){
          this.$emit('close');
        }
      }
    }

</script>
<style scope>
.appliancesDetail .el-dialog__body{
  height: 500px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/appliancesDetail.vue